// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1N9oe","text":"card-module--text--1DR3w","invert":"card-module--invert--10uGx"};